import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";
import { useOperationHoursPermissions } from "../../hooks/useOperationHoursPermissions";
import STRINGS from "../../utils/strings";
import AddButton from "../buttons/AddButton";

export default function EditCellHeader({ day, index, onAdd }) {
  const { canAddHoursOfOperation } = useOperationHoursPermissions();
  return (
    canAddHoursOfOperation && 
    (<div className="flex flex-row justify-between py-2">
      <div className="flex flex-col gap-1">
        <Typography
          className="text-[14px] font-semibold"
          sx={{ color: HNSColors.neutrals[100] }}
        >
          {`${day}`}
        </Typography>
        <Typography className="text-[12px] font-normal">
          {`Edit Time Window`}
        </Typography>
      </div>
      <AddButton label={STRINGS.BUTTON_LABELS.ADD_NEW_WINDOW} handleAdd={() => onAdd(index)}/>
    </div>)
  );
}